import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { SelectionTestDialogComponent } from '../selection-test-dialog/selection-test-dialog.component';
import { NotificationService } from 'src/services/notification.service';
import { ProcessListInterviewSessionDialogComponent } from '../process-list-interview-session-dialog/process-list-interview-session-dialog.component';
import { NewInterviewComponent } from '../new-interview/new-interview.component';

@Component({
  selector: 'app-selection-test',
  templateUrl: './selection-test.component.html',
  styleUrls: ['./selection-test.component.scss']
})
export class SelectionTestComponent implements OnInit {
  tests: Array<any> = [];
  pagedTests: Array<any> = [];
  private currentUser: any;
  interviews: Array<any> = [];

  // Pagination variables
  pageSize: number = 5;
  pageIndex: number = 0;
  interviewsPageSize: number = 5;
  interviewsPageIndex: number = 0;
  pagedInterviews: Array<any> = [];

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('token'));
    this.getSelectionTest();
    this.getInterviews();
  }

  openTestDialog(test = null) {
    if (
      this.currentUser.signature_status !== 'ACTIVE' &&
      this.currentUser.signature_status !== 'TRIAL' &&
      this.currentUser.account_type !== 'candidate'
    ) {
      this.notificationService.showAccountActivationMessage();
    } else {
      const options = {
        disableClose: true,
        width: '800px',
        data: { test }
      };
      this.dialog
        .open(SelectionTestDialogComponent, options)
        .afterClosed()
        .subscribe(result => {
          if (result) this.getSelectionTest();
        });
    }
  }

  getSelectionTest() {
    const params = {
      companyId: this.currentUser.company_id
    };

    this.http.list('selection_test', params).subscribe(
      (tests: any) => {
        this.tests = tests;
        this.updatePagedTests();
      },
      err => this.errorReport.showMessage(err)
    );
  }

  removeSelectionTest(test) {
    if (!confirm('Deseja realmente excluir esse teste?')) return;

    const params = {
      id: test.id
    };
    this.http.delete('selection_test', params).subscribe(
      (result: any) => {
        if (result.type === 'OK') this.getSelectionTest();
        else if (result.type === 'FAIL')
          this.snackbar.open(
            'Não foi possivel excluir esse teste, ele esta sendo usado nos candidatos',
            'OK',
            { duration: 3000 }
          );
      },
      err => this.errorReport.showMessage(err)
    );
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updatePagedTests();
  }

  updatePagedTests() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    if(this.tests){
      this.pagedTests = this.tests.slice(startIndex, endIndex);
    }
  }

  onInterviewsPageChange(event: PageEvent) {
    this.interviewsPageSize = event.pageSize;
    this.interviewsPageIndex = event.pageIndex;
    this.updatePagedInterviews();
  }

  updatePagedInterviews() {
    const startIndex = this.interviewsPageIndex * this.interviewsPageSize;
    const endIndex = startIndex + this.interviewsPageSize;
    this.pagedInterviews = this.interviews.slice(startIndex, endIndex);
  }

  getInterviews() {

    this.http.list('process_list:interview_all', { company: this.currentUser.company_id })
      .subscribe(
        (result: any) => {
          this.interviews = result.data;
          this.updatePagedInterviews(); // Atualiza os dados paginados
        }
      )

  }

  openInterviewSession(event: Event, interview) {
    
    event.stopPropagation();

    const options = {
      disableClose: true,
      width: '900px',
      data: {
        processListId: interview.process_list,
        interview,
        processList: { name: interview.process_list_name }
      }
    }
    this.dialog.open(ProcessListInterviewSessionDialogComponent, options)

  }

  newInterview() {

    const options = {
      disableClose: true,
      width: '800px',
    }
    this.dialog.open(NewInterviewComponent, options)
    .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.getInterviews();
        }
      );
  }

  openSelectionInterview(event: Event, interview) {
    
    event.stopPropagation();

    const [hours, mantissa] = (parseInt(interview.candidates_session_duration) / 60).toFixed(2).split('.');
    const minutes = Math.floor((((parseInt(mantissa) / 100)) * 60));

    const options = {
      disableClose: true,
      width: '900px',
      data: {
        processListId: interview.process_list,
        id: interview.id,
        name: interview.name,
        dateStart: interview.date_start,
        timeStart: interview.time_start,
        timeEnd: interview.time_end,
        nextDays: interview.next_days,
        contact: interview.contact,
        address: interview.address,
        candidatesSessionDuration: `${hours.padStart(2, '0')}:${minutes}`,
        type: interview.type === 'true' || false,
      }
    }
    this.dialog.open(NewInterviewComponent, options)
    .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.getInterviews();
        }
      );

  }

  deleteInterview(args, interview) {

    args.stopPropagation();

    if (!confirm(`Deseja realmente deletar essa entrevista ?`))
      return;

    const data = { id: interview.id };
    this.http.delete('process_list:interview', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK'){
            this.snackbar.open('Entrevista Deletada com Sucesso !!!', 'OK', { duration: 3000 })
            this.getInterviews();
          } else if (result.type === 'FAIL'){
            this.snackbar.open('Essa entrevista não pode ser excluida, já foi agendada por um ou mais candidatos', 'OK', { duration: 3000 })
            //this.selectInterviewMode = false;
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  formatTime(time: string): string {
    return time.substring(0, 5); // Retorna apenas os primeiros 5 caracteres (HH:mm)
  }

}
